let aduio_video = {
  callHungupNet: {
    //拆线/挂断

    /***对某个通话用户拆线/挂断，使其停止通话，适用于语音和视频通话 或者 将号码踢出会场**/
    url: '/dispatch-web/api/call/hungup',
    requestParam: {
      token: '',
      tel: '' //通话号码

    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: ''
    }
  },
  listStatusNet: {
    //获取当前所有号码状态
    url: '/dispatch-web/api/call/listStatus',
    requestParam: {
      token: ''
    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      total: '',
      list: [{
        //记录列表，[0, n]个TelStatus。
        tel: '',
        //号码
        businessId: '',
        //业务id
        status: '',
        //号码状态
        recording: '',
        //是否在录音中
        handleNumber: '',
        //主叫号码
        meetId: '',
        //会议号，如在会议中该值有内容
        conNumber: '',
        //与tel通话的号码
        videoInfo: '' //通话类型 audio:语音通话， video：视频通话

      }]
    }
  },
  telsStatusNet: {
    //获取号码状态, 无法获取准确的记录仪的在线离线状态， 需要另外一个接口queryFacilityList辅助完善号码状态的查询
    url: '/dispatch-web/api/call/telsStatus',
    requestParam: {
      token: '',
      tels: '' //查询状态的号码，用’,’隔开

    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      total: '',
      list: [{
        //记录列表，[0, n]个TelStatus。
        tel: '',
        //号码
        businessId: '',
        //业务id
        status: '',
        //号码状态
        recording: '',
        //是否在录音中
        handleNumber: '',
        //主叫号码
        meetId: '',
        //会议号，如在会议中该值有内容
        conNumber: '',
        //与tel通话的号码
        videoInfo: '' //通话类型 audio:语音通话， video：视频通话

      }]
    }
  },
  telsStatusAssistNet: {
    url: '/gpsid_server/data/member/listOrgMember',
    method: 'POST',
    paramOnUrl: ['token'],
    requestParam: {
      token: '',
      tels: '' //查询状态的号码，用’,’隔开

    },
    responseParam: {
      code: '',
      //返回结果状态码
      message: '',
      systemTime: '',
      //yyyy-MM-dd HH:mm:ss
      data: {
        total: '',
        list: [{
          //记录列表，[0, n]个TelStatus。
          "memId": 7,
          //成员id
          "memName": "",
          //成员名称
          "memType": 2,
          //成员类型，0-一般用户；1-视频话机用户；2-移动终端用户；5-对讲用户
          "memTel": "8012",
          //成员号码
          "memMobile": "",
          //成员手机号码
          "deptId": 14,
          //部门id
          "deptName": "浙江省人防办",
          //部门名称
          "actived": 0,
          //是否在线，0-离线，1-在线
          "latitude": 120.153577,
          //经度
          "longitude": 30.270569,
          //纬度
          "updateTime": "2022-09-22 10:07:00" //更新时间

        }]
      }
    }
  },
  telsStatusMQNet: function (accId) {
    return {
      //号码状态改变通知
      topic: `/${accId}/dispatch-web/notify/call/telStatus`,
      responseParam: {
        id: 0,
        //数据id
        type: 'telStatus',
        //消息类别
        source: 'dispatch-web',
        //消息来源
        data: {
          //通知的具体消息
          tel: '',
          //被通知状态的号码
          status: '',
          //号码状态
          handleNumber: '',
          //主叫号码 F
          conNumber: '',
          //通话号码 F
          meetId: '',
          //会议ID F
          videoInfo: '',
          //呼叫类型 audio: 语音; video:视频
          accId: '',
          //消息接收的账号id
          account: '' //消息接收的账号名

        }
      }
    };
  },
  callInMQNet: function (accId) {
    return {
      //呼入队列改变通知
      topic: `/${accId}/dispatch-web/notify/call/callIn`,
      responseParam: {
        id: 0,
        //数据id
        type: 'callIn',
        //消息类别
        source: 'dispatch-web',
        //消息来源
        data: {
          //通知的具体消息
          tel: '',
          //被通知状态的号码
          type: '',
          //队列改变类型  add: 新增呼入 del: 去除呼入
          time: '',
          //yyyy-MM-dd HH:mm:ss
          level: '',
          //号码等级 -1:默认 2：普通紧急电话 3：其他成员电话
          accId: '',
          //消息接收的账号id
          account: '' //消息接收的账号名

        }
      }
    };
  },
  groupNotifyMQNet: function (accId) {
    return {
      //组呼通知结果通知
      topic: `/${accId}/dispatch-web/notify/call/groupNotify`,
      responseParam: {
        id: 0,
        //数据id
        type: 'groupNotify',
        //消息类别
        source: 'dispatch-web',
        //消息来源
        data: {
          //通知的具体消息
          result: '',
          //操作结果
          desc: '',
          //组呼通知结果文字描述
          descJson: '',
          //组呼通知结果json格式  totalCount：组呼总数 sucCount：成功总数 sucTels：成功号码,|分隔 failTels：失败号码，|分隔 dtmf:回复统计
          accId: '',
          //消息接收的账号id
          account: '' //消息接收的账号名

        }
      }
    };
  },
  telsStatusHttpNet: {
    //号码状态改变通知Http推送方式
    url: '/notify/call/telStatus',
    method: 'POST',
    //推送当前状态改变的号码及改变后的状态信息
    requestParam: {
      tel: '',
      //号码
      status: '',
      //状态
      handleNumber: '',
      // 主叫号码
      conNumber: '',
      // 通话号码
      meetId: '',
      // 会议id
      videoInfo: '',
      // 呼叫类型 audio: 语音; video:视频
      accId: '',
      //消息接收的账号id
      account: '' //消息接收的账号名

    },
    responseParam: {
      code: '' //返回结果状态码

    }
  },
  callInHttpNet: {
    //呼入队列改变通知Http推送方式
    url: '/notify/call/callIn',
    method: 'POST',
    //推送当前呼入队列的成员改变通知
    requestParam: {
      type: '',
      //队列改变类型 add: 新增呼入 del: 去除呼入
      tel: '',
      // 被通知状态的号码
      time: '',
      //yyyy-MM-dd HH:mm:ss
      level: '',
      //等级 -1:默认 2：普通紧急电话 3：其他成员电话
      accId: '',
      //消息接收的账号id
      account: '' //消息接收的账号名

    },
    responseParam: {
      code: '' //返回结果状态码

    }
  },
  groupNotifyHttpNet: {
    //组呼通知结果通知Http推送方式
    url: '/notify/call/groupNotify',
    method: 'POST',
    //推送组呼通知结果
    requestParam: {
      result: '',
      //操作结果
      desc: '',
      //组呼通知结果文字描述
      descJson: '',
      // 组呼通知结果json格式 totalCount：组呼总数 sucCount：成功总数 sucTels：成功号码,|分隔 failTels：失败号码，|分隔 dtmf:回复统计
      accId: '',
      //消息接收的账号id
      account: '' //消息接收的账号名

    },
    responseParam: {
      code: '' //返回结果状态码

    }
  },
  videoStatusHttpNet: {
    //视频通话状态通知Http推送方式
    url: '/notify/call/video',
    method: 'POST',
    //推送视频通话状态通知
    requestParam: {
      cfgType: '',
      //视频通话状态 decoder_info：视频通话建立 stop_decoder:视频通话结束
      tel: '',
      //通知号码
      accId: '',
      //消息接收的账号id
      account: '' //消息接收的账号名

    },
    responseParam: {
      code: '' //返回结果状态码

    }
  }
};
export default aduio_video;